import { IAction } from '../utils';
import { reducerTypes } from './types';
import * as en from '../../localeTexts/en';
import { HYDRATE } from 'next-redux-wrapper';

export const INITIAL: { [key: string]: string } = en.texts;

export const localeReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case HYDRATE:
      // Attention! This will overwrite client state! Real apps should use proper reconciliation.
      return { payload };
    case reducerTypes.GET_SELECTED_LOCALE:
      return payload;
    default:
      return state;
  }
};
